import { EditableInfoCard, SubmitProps } from '@/components/editable-info-card';
import { buildUserIdentitiesDefaultValues } from '@/lib/user-identity-utils';
import { UserIdentityProviderKey, type FullStudent, updateUserIdentitiesOptionsSchema } from '@airreading/common/data';
import { z } from 'zod';
import { UserIdentityProviderFields } from './user-identity-provider-fields';

export const editUserIdentitiesFormSchema = updateUserIdentitiesOptionsSchema;
export type EditUserIdentitiesForm = z.infer<typeof editUserIdentitiesFormSchema>;

interface SsoInfoCardProps {
  student: FullStudent;
  onSubmit: (props: SubmitProps<EditUserIdentitiesForm>) => unknown;
}

export function SsoInfoCard({ student, onSubmit }: SsoInfoCardProps) {
  const defaultValues = buildUserIdentitiesDefaultValues(student);
  const { google, edlink } = defaultValues;

  return (
    <EditableInfoCard
      key={`sso-info-${student.id}-${JSON.stringify(student.userIdentities)}`}
      headerText="SSO info"
      formSchema={editUserIdentitiesFormSchema}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
    >
      {({ form, editing }) => (
        <div className="flex flex-col gap-2">
          <UserIdentityProviderFields
            providerKey={UserIdentityProviderKey.google}
            title="Google workspace user identity"
            form={form}
            editing={editing}
            provider={google}
          />
          <UserIdentityProviderFields
            providerKey={UserIdentityProviderKey.edlink}
            title="Edlink user identity"
            form={form}
            editing={editing}
            provider={edlink}
          />
        </div>
      )}
    </EditableInfoCard>
  );
}
